// material-ui
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

// ==============================|| Loader ||============================== //

const Processing = (value) => (
  <Backdrop sx={{ color: '#fff', zIndex: 20001 }}
        open={value} >
        <CircularProgress color="inherit" />
  </Backdrop>

);

export default Processing;
